// Sun Valley : plan d'accès d'une fiche boutique (sections/sv-boutique.liquid), affiché quand la
// boutique n'a pas encore de photo. Leaflet chargé à la demande, fond OpenStreetMap, marqueur
// de la page Boutiques ; un clic sur le marqueur ouvre l'itinéraire.
(() => {
  if (customElements.get('sv-boutique-plan')) return;
  customElements.define('sv-boutique-plan', class extends HTMLElement {
    connectedCallback() {
      // Chargé quand le plan approche de l'écran : sur mobile, il est sous les informations.
      const io = new IntersectionObserver((e) => { if (e.some((x) => x.isIntersecting)) { io.disconnect(); this.dessiner(); } }, { rootMargin: '200px' });
      io.observe(this);
    }

    async dessiner() {
      if (!window.L) {
        await new Promise((ok, ko) => { const s = document.createElement('script'); s.src = this.dataset.leaflet; s.onload = ok; s.onerror = ko; document.head.appendChild(s); });
      }
      const L = window.L;
      const point = [Number(this.dataset.lat), Number(this.dataset.lng)];
      const carte = L.map(this, { scrollWheelZoom: false, zoomControl: true, attributionControl: true }).setView(point, 15);
      carte.attributionControl.setPrefix(false); // la mention OpenStreetMap, obligatoire, reste
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; OpenStreetMap' }).addTo(carte);
      const icone = L.divIcon({ className: 'sv-boutiques__marqueur', html: '<span></span>', iconSize: [22, 22], iconAnchor: [11, 22] });
      const m = L.marker(point, { icon: icone, title: this.dataset.nom, keyboard: true }).addTo(carte);
      if (this.dataset.itineraire) m.on('click', () => window.open(this.dataset.itineraire, '_blank', 'noopener'));
    }
  });
})();
